import { Link } from 'react-router-dom'
import { FileQuestion } from 'lucide-react'

interface ContentNotFoundProps {
  type: 'guide' | 'changelog'
  slug: string
  allSections: { slug: string; title: string }[]
}

export function ContentNotFound({ type, slug, allSections }: ContentNotFoundProps) {
  // Compute suggestions: sections whose slug or title partially match the requested slug
  const lowerSlug = slug.toLowerCase()
  const suggestions = allSections
    .filter(
      (s) =>
        s.slug.toLowerCase().includes(lowerSlug) ||
        s.title.toLowerCase().includes(lowerSlug) ||
        lowerSlug.includes(s.slug.toLowerCase())
    )
    .slice(0, 3)

  const basePath = type === 'guide' ? '/guide' : '/changelog'
  const browseLabel =
    type === 'guide' ? 'Browse all guide sections' : 'Browse all releases'

  return (
    <div className="py-16 text-center">
      <FileQuestion className="w-12 h-12 mx-auto text-muted-foreground mb-4" />
      <h2 className="text-xl font-semibold mb-2">Section Not Found</h2>
      <p className="text-muted-foreground mb-6 max-w-md mx-auto">
        We couldn't find a {type === 'guide' ? 'guide section' : 'release'} matching{' '}
        <span className="font-mono text-foreground">"{slug}"</span>.
      </p>

      {suggestions.length > 0 && (
        <div className="mb-6">
          <p className="text-sm text-muted-foreground mb-3">Did you mean?</p>
          <div className="flex flex-col items-center gap-2">
            {suggestions.map((s) => (
              <Link
                key={s.slug}
                to={`${basePath}/${s.slug}`}
                className="text-primary hover:underline text-sm"
              >
                {s.title}
              </Link>
            ))}
          </div>
        </div>
      )}

      <Link
        to={basePath}
        className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-secondary hover:bg-secondary/80 text-sm font-medium transition-colors"
      >
        {browseLabel}
      </Link>
    </div>
  )
}
